import Glightbox from "glightbox/src/js/glightbox";
import {checkForImageUrl} from "../helpers/miscHelpers";
const handleLightboxSetup = () => {
    if(document.querySelector('.wp-block-image')){
        // init lightbox
        const lightbox = Glightbox(
            {
                touchNavigation: true,
                loop: true,
            }
        );

        document.addEventListener('click', ev =>{
            if(!ev.target.closest('.wp-block-image')) return;
            ev.preventDefault();
            let link = ev.target.closest('a');

            if(link !== null ){
                if(!checkForImageUrl(link.href)){
                    if(link.getAttribute('target') === '_blank'){
                        window.open(link.href, '_blank', 'noopener, noreferrer')
                    } else{
                        location.href = link.href;
                    }

                    return;
                }
                let elements = []
                let chosenIndex = 0;
                if(link.closest('.wp-block-gallery')){

                    let gallery = link.closest('.wp-block-gallery');
                    let allImageLinks = gallery.querySelectorAll('.wp-block-image > a');

                    let i = 0;
                    allImageLinks.forEach( l => {

                        if(checkForImageUrl(l.href)){

                            if(l === link){
                                chosenIndex = i;
                            }
                            i++;
                            elements.push(
                                {
                                    'href': l.href,
                                    'type': 'image'
                                }
                            );
                        }

                    })
                }
                if(!link.closest('.wp-block-gallery')){
                    elements.push(
                        {
                            'href': link.href,
                            'type': 'image'
                        }
                    );
                }
                lightbox.setElements(elements);
                lightbox.settings.startAt = chosenIndex;
                lightbox.open();
            }


        })
    }
}
export default handleLightboxSetup;